module.exports = __webpack_public_path__ + "img/AddBusinessOutlined.2a6acd81.svg";